export default __webpack_public_path__ + "static/media/highlevel.d7636215.png";